// region External Modules
import on_domready from "domready"
// endregion External Modules

// Private Modules
import ImageLazyLoading from "widgets/image_lazyloading"
// Private Modules

import {
  Factory as MarketNewsOverseas,
} from "./components/market_news/index"
import {
  Factory as OverseasMarketingFilter,
} from "./components/overseas_marketing_filter/index"

const init = ()  => {
  MarketNewsOverseas.create()
  OverseasMarketingFilter.create()

  on_domready(() => {
    ImageLazyLoading.default_lazyload_instance().update()
  })
}

export default {
  init: init,
}
